var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"297.5,148.25 148,33.25 148,100.25 0,100.25 0,199.25 148,199.25 148,264.25 "}));
}

Right.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 297.5 297.5","style":{"enableBackground":"new 0 0 297.5 297.5"},"xmlSpace":"preserve"};

module.exports = Right;

Right.default = Right;
